import React from 'react';
import { Wrap, Title, Description } from './OfferDetailsModal.styled';

const OfferDetailsModal = ({ title, longDescription }) => (
  <Wrap>
    <Title>{title}</Title>
    <Description dangerouslySetInnerHTML={{ __html: longDescription }} />
  </Wrap>
);

export default OfferDetailsModal;
